
export default function ProcessSection() {
  const steps = [
    {
      number: '1',
      title: 'Análise Inicial',
      description: 'Envie os documentos do seu precatório para nossa análise gratuita e receba uma avaliação completa.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20person%20analyzing%20financial%20documents%20at%20modern%20office%20desk%2C%20reviewing%20legal%20papers%20and%20contracts%2C%20clean%20white%20background%2C%20realistic%20photography%20style%2C%20person%20wearing%20business%20attire%2C%20focused%20on%20paperwork%20analysis%2C%20bright%20natural%20lighting%2C%20documentary%20style%20photo&width=400&height=300&seq=analysis-step&orientation=landscape'
    },
    {
      number: '2',
      title: 'Proposta Personalizada',
      description: 'Elaboramos uma proposta sob medida baseada no valor e características do seu precatório.',
      image: 'https://readdy.ai/api/search-image?query=Business%20professional%20presenting%20official%20proposal%20document%20at%20office%20meeting%20table%2C%20formal%20business%20setting%2C%20person%20in%20professional%20attire%20showing%20contract%20papers%2C%20clean%20white%20background%2C%20realistic%20corporate%20photography%2C%20focused%20on%20document%20presentation%2C%20bright%20office%20lighting&width=400&height=300&seq=proposal-step&orientation=landscape'
    },
    {
      number: '3',
      title: 'Negociação',
      description: 'Nossos especialistas negociam as melhores condições para maximizar o valor da sua venda.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20business%20meeting%20with%20handshake%20agreement%2C%20two%20people%20in%20business%20suits%20negotiating%20deal%20at%20modern%20office%20table%2C%20clean%20white%20background%2C%20realistic%20corporate%20photography%20style%2C%20focused%20on%20business%20negotiation%20moment%2C%20bright%20professional%20lighting&width=400&height=300&seq=negotiation-step&orientation=landscape'
    },
    {
      number: '4',
      title: 'Assinatura e Pagamento',
      description: 'Assinatura do contrato em cartório e recebimento do valor à vista no mesmo dia.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20person%20signing%20important%20legal%20contract%20document%20at%20notary%20office%2C%20formal%20business%20setting%2C%20hand%20with%20pen%20signing%20papers%2C%20clean%20white%20background%2C%20realistic%20photography%20style%2C%20focused%20on%20contract%20signing%20moment%2C%20bright%20office%20lighting&width=400&height=300&seq=signing-step&orientation=landscape'
    }
  ];

  return (
    <section id="processo" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-left mb-16">
          <p className="text-yellow-600 font-medium mb-4 uppercase tracking-wide" style={{ fontFamily: 'Open Sans, sans-serif' }}>
            COMO FUNCIONA
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Antecipe seu<br />
            pagamento em<br />
            4 passos simples
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="group">
              <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="aspect-w-4 aspect-h-3 bg-gray-100">
                  <img 
                    src={step.image} 
                    alt={step.title}
                    className="w-full h-48 object-cover"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    <span className="text-2xl font-bold text-blue-900 mr-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {step.number}
                    </span>
                    <span className="text-gray-400 text-xl">-</span>
                    <h3 className="text-lg font-semibold text-gray-900 ml-3" style={{ fontFamily: 'Poppins, sans-serif' }}>
                      {step.title}
                    </h3>
                  </div>
                  <p className="text-gray-600 leading-relaxed text-sm" style={{ fontFamily: 'Open Sans, sans-serif' }}>
                    {step.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="flex justify-center mt-12">
          <div className="flex space-x-4">
            <button className="w-12 h-12 rounded-full border-2 border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-white transition-all duration-300 flex items-center justify-center">
              <i className="ri-arrow-left-line text-xl"></i>
            </button>
            <button className="w-12 h-12 rounded-full bg-yellow-600 text-white hover:bg-yellow-700 transition-all duration-300 flex items-center justify-center">
              <i className="ri-arrow-right-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
